import { motion } from "framer-motion";
import { CalendarCheck, Phone, Clock } from "lucide-react";
import { CONTACT, RESERVATION_URL } from "../data/content";

export const ReserveSection = () => {
    return (
        <section id="reserve" className="py-24 md:py-32 px-6 md:px-10 bg-[#00958C]" data-testid="reserve-section">
            <div className="max-w-4xl mx-auto text-center">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                >
                    <p className="font-serif-brand italic text-xl text-[#FFF7C5] mb-4">Your table under the trees</p>
                    <h2 className="text-4xl md:text-6xl font-bold tracking-tighter text-white leading-tight" data-testid="reserve-headline">
                        Reserve a Table
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-xl mx-auto" data-testid="reserve-subcopy">
                        Book your calm corner in a few taps, for your family, your friends, and
                        your pets too. Reservations are handled live through our booking partner.
                    </p>

                    <a
                        href={RESERVATION_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="reserve-booking-button"
                        className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#F0841B] text-white font-semibold text-lg px-12 py-5 shadow-2xl shadow-[#262055]/30 hover:brightness-110 hover:-translate-y-1 transition-[transform,filter] duration-200"
                    >
                        <CalendarCheck size={22} />
                        Book Your Table
                    </a>

                    <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 text-white/85 text-sm" data-testid="reserve-contact-alt">
                        <span className="flex items-center gap-2">
                            <Phone size={16} className="text-[#FFF7C5]" />
                            <a href={`tel:${CONTACT.phonePrimary.replace(/\s/g, "")}`} className="font-semibold hover:text-white transition-colors" data-testid="reserve-phone-link">{CONTACT.phonePrimary}</a>
                            <span className="text-white/50">/</span>
                            <a href={`tel:${CONTACT.phoneSecondary.replace(/\s/g, "")}`} className="font-semibold hover:text-white transition-colors" data-testid="reserve-phone-link-2">{CONTACT.phoneSecondary}</a>
                        </span>
                        <span className="flex items-center gap-2" data-testid="reserve-hours">
                            <Clock size={16} className="text-[#FFF7C5]" />
                            {CONTACT.hours}
                        </span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
